
















import { Vue, Component } from "vue-property-decorator";
import LectureListView from "@/components/lectures/LectureListView.vue";

@Component({
  components: { LectureListView }
})
export default class lectureList extends Vue {}
